import { configureProduct, pageLeave, pageView } from '@engage-web/product';

export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig();

  if (runtimeConfig.public.posthogEnabled === 'true') {
    configureProduct({
      token: runtimeConfig.public.posthogToken,
      host: runtimeConfig.public.posthogDns,
      anonymous: true,
    });

    // Make sure that pageviews are captured with each route change
    const router = useRouter();
    router.afterEach((to, from, failure) => {
      if (!failure) {
        pageLeave(from.fullPath, to.fullPath);
        nextTick(() => pageView(to.fullPath));
      }
    });
  }
});
